import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
export const Transition = ({ heading, body, hideHeading = false }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        !hideHeading && !open &&
            React.createElement("span", { onClick: () => setOpen(!open), "aria-controls": "collapse-text", "aria-expanded": open }, heading),
        React.createElement(Collapse, { in: open },
            React.createElement("div", { id: "collapse-text", className: "cursor-pointer word-break-all", onClick: () => setOpen(!open) }, body))));
};
export default Transition;
